module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wap-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "wap-phone"
  }, [_c('div', {
    staticClass: "wap-header"
  }, [_c('div', {
    staticClass: "wap-avatar"
  }, [_vm._v("N")]), _vm._v(" "), _c('div', {
    staticClass: "wap-header-text"
  }, [_c('div', {
    staticClass: "wap-name"
  }, [_vm._v(_vm._s(_vm.journeyName))]), _vm._v(" "), _c('div', {
    staticClass: "wap-status"
  }, [_vm._v(_vm._s(_vm.statusText))])]), _vm._v(" "), (_vm.langOptions.length > 1) ? _c('nv-select', {
    staticClass: "wap-lang-select",
    attrs: {
      "value": _vm.lang,
      "title": "Preview in a different language"
    },
    on: {
      "change": function($event) {
        return _vm.onLangChange($event.target.value)
      }
    }
  }, _vm._l((_vm.langOptions), function(o) {
    return _c('option', {
      key: o.code,
      domProps: {
        "value": o.code
      }
    }, [_vm._v(_vm._s(o.label))])
  }), 0) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "wap-close",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    ref: "body",
    staticClass: "wap-body"
  }, [_vm._l((_vm.messages), function(m, i) {
    return _c('div', {
      key: i,
      staticClass: "wap-bubble",
      class: m.role
    }, [_vm._v(_vm._s(m.text)), _c('div', {
      staticClass: "wap-time"
    }, [_vm._v(_vm._s(m.time))])])
  }), _vm._v(" "), (_vm.pendingOptions.length) ? _c('div', {
    staticClass: "wap-options"
  }, _vm._l((_vm.pendingOptions), function(o, i) {
    return _c('button', {
      key: i,
      staticClass: "wap-opt-btn",
      on: {
        "click": function($event) {
          return _vm.chooseOption(o)
        }
      }
    }, [_vm._v(_vm._s(o.label))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.ended) ? _c('div', {
    staticClass: "wap-end-note"
  }, [_vm._v("Conversation ended")]) : _vm._e(), _vm._v(" "), (!_vm.currentStageName) ? _c('div', {
    staticClass: "wap-end-note"
  }, [_vm._v("This journey has no stages yet")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "wap-foot"
  }, [_c('button', {
    staticClass: "wap-restart-btn",
    on: {
      "click": _vm.restart
    }
  }, [_vm._v("↻ Restart conversation")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0e729f4b","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/WhatsAppPreview.vue
// module id = iIus
// module chunks = 1